import { twMerge } from '@sortlist-frontend/design-system';
import type { PropsWithChildren } from 'react';

interface RankingCardProps {
  className?: string;
}

export const RankingCard = (props: PropsWithChildren<RankingCardProps>) => {
  const { className, children } = props;

  return (
    <div
      className={twMerge('min-w-0 rounded-2xl border border-secondary-200 bg-white p-5 shadow-xs md:p-6', className)}>
      {children}
    </div>
  );
};
